import { MeteorObservable } from 'meteor-rxjs';
import { Component, OnInit } from '@angular/core';
import { NavParams } from 'ionic-angular';

import { Project } from 'api/models';
import { ProjectInfo } from '../project-info/project-info';
import { ProjectUsers } from '../project-users/project-users';
import { CurrentUpdate } from '../current-update/current-update';
import { ArchivedUpdates } from '../archived-updates/archived-updates';
// import { getCompany } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import * as permissions from '../../services/permissions';
import { ISDEV, APP_TITLE } from "../../services/config";
import { App } from "ionic-angular";
import { AuthenticationService } from '../../services/congito';
import { HttpService } from '../../services/httpService';

@Component({
  selector: 'project-detail-tabs',
  templateUrl: 'project-detail-tabs.html'
})
export class ProjectDetailTabsPage implements OnInit {
  public isDev = ISDEV;
  projectInfoTab = ProjectInfo;
  projectUsersTab = ProjectUsers;
  currentUpdateTab = CurrentUpdate;
  archivedUpdatesTab = ArchivedUpdates;
  showUpdateTabs: boolean;
  showNavigationBar: boolean;
  tabParams: Object;
  project: Project | void;

  constructor(
    private _app: App,
    public navParams: NavParams,
    public companyService: CompanyService,
    public projectService: ProjectService,
    public authenticationService: AuthenticationService,
    public httpService: HttpService
  ) {
    this.showNavigationBar = <boolean>navParams.get('showNavigationBar');

    this.tabParams = navParams.data; // pass through the params to the individual tab views
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  ngOnInit() {
    MeteorObservable.autorun().subscribe(() => {
      const viewer = this.authenticationService.MeteorUser();
      const projectIdReactive = this.navParams.get('projectIdReactive');
      const projectId =  projectIdReactive && projectIdReactive.get();
      this.project = this.projectService.getProject(projectId);
      const company = this.project ? this.companyService.getCompany(this.project.companyId) : null;

      const isCompanyAdmin = permissions.isCompanyAdmin(company, viewer);
      const isSuperUser = permissions.isSuperAdmin(viewer);
      const isProjectManager = this.project ? permissions.isProjectManager(this.project, viewer) : false;
      this.showUpdateTabs = isCompanyAdmin || isProjectManager || isSuperUser;
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/project-detail-tabs/project-detail-tabs.ts